import { Injectable, signal, computed, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { TenantService } from '../tenant/tenant.service';

const LEGACY_STORAGE_KEY = 'taskeo-sidebar-collapsed';

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  private readonly auth = inject(AuthService);
  private readonly tenant = inject(TenantService);

  private readonly collapsedSignal = signal<boolean>(this.readStored());

  readonly isCollapsed = this.collapsedSignal.asReadonly();
  readonly isExpanded = computed(() => !this.collapsedSignal());

  toggle(): void {
    const next = !this.collapsedSignal();
    this.setCollapsed(next);
  }

  setCollapsed(collapsed: boolean): void {
    this.collapsedSignal.set(collapsed);
    try {
      const key = this.getStorageKey();
      localStorage.setItem(key, String(collapsed));
    } catch {}
  }

  expand(): void {
    this.setCollapsed(false);
  }

  init(): void {
    this.collapsedSignal.set(this.readStored());
  }

  private getStorageKey(): string {
    const companyId = this.tenant.getActiveCompanyId();
    const user = this.auth.user();
    const userId = user?.id;

    if (companyId && userId) {
      // taskeo.sidebar.collapsed.{companyId}.{userId}
      return `taskeo.sidebar.collapsed.${companyId}.${userId}`;
    }

    return LEGACY_STORAGE_KEY;
  }

  private readStored(): boolean {
    try {
      const key = this.getStorageKey();
      const v = localStorage.getItem(key) ?? localStorage.getItem(LEGACY_STORAGE_KEY);
      return v === 'true';
    } catch {}
    return false;
  }
}
